<template>
  <div class="d-flex flex-column align-center">
    <div class="title mb-2">
      {{$t('Фон обложки')}}
    </div>
    <ColorPicker @change-color="changeColor" :hide-eye-dropper="true" :default-color="initColor" v-if="initColor" :swatch-colors="colors"/>
    <v-btn variant="flat" color="primary" @click="saveBackground()" rounded="lg" class="w-100 mt-4">
      {{$t('Применить')}}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { useTapStore } from '@/stores/tapStore'
import {useDialogStore} from "@/stores/dialogStore";
import {useColorStore} from "@/stores/colorStore";
import {onMounted, ref} from "vue";

const tapStore = useTapStore()
const colorStore = useColorStore()
const dialogStore = useDialogStore()

const color = ref('')
const colors = ref()
const initColor = ref()

const changeColor = (c) => {
  color.value = c
}

const saveBackground = () => {
  tapStore.setTapBackground(color.value)
  colorStore.add(color.value)
  dialogStore.close()
  tapStore.currentTapLang.infoChanged = true
}

onMounted(async () => {
  colors.value = await colorStore.get()
  initColor.value = tapStore.currentTapLang?.backgroundColor == '#FFFFFF' || !tapStore.currentTapLang?.backgroundColor ? '#0D87EF' : tapStore.currentTapLang?.backgroundColor;
})
</script>

<style scoped lang="sass">
.title
  color: #363636
  text-align: center
  font-size: 20px
  font-style: normal
  font-weight: 600
  line-height: normal
</style>
